import { render } from "./BaseToggle.vue?vue&type=template&id=b89d0e5c&scoped=true"
import script from "./BaseToggle.vue?vue&type=script&lang=js"
export * from "./BaseToggle.vue?vue&type=script&lang=js"

import "./BaseToggle.vue?vue&type=style&index=0&id=b89d0e5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b89d0e5c"]])

export default __exports__